export default [
  {
    group: '/votacion',
    model: false,
    // icon: 'mdi-account',
    avatar: require('@/assets/images/elections.svg'),
    title: 'VOTACIÓN',
    meta: {
      code: '*'
    },
    children: [
      {
        icon: 'mdi-developer-board',
        title: 'Realizar Votación',
        to: 'votar',
        meta: {
          code: 'votar'
        }
      },
      {
        icon: 'mdi-developer-board',
        title: 'Analiticas',
        to: 'analiticas',
        meta: {
          code: 'analiticas'
        }
      },
      {
        icon: 'mdi-developer-board',
        title: 'Reportes',
        to: 'reportes',
        meta: {
          code: 'reportes'
        }
      }
    ]
  }
];
